import { render } from "./Clients.vue?vue&type=template&id=274e8dd6&scoped=true"
import script from "./Clients.vue?vue&type=script&lang=js"
export * from "./Clients.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-274e8dd6"

export default script